module.exports = require("./es-EA");